module.exports = __webpack_public_path__ + "static/media/schoolsonweb-logo-only.a3625467.png";